import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import MenuBar from "../../components/resident/MenuBar";
import Footer from "../../components/resident/Footer";

const ClientLayout = ({ theme, toggleTheme }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div>
      <MenuBar
        isMenuOpen={isMenuOpen}
        setIsMenuOpen={setIsMenuOpen}
        theme={theme}
        toggleTheme={toggleTheme} // 👈 pass to MenuBar
      />

      <div className="mx-auto">
        <Outlet context={{ isMenuOpen, theme }} />
      </div>

      <Footer theme={theme} />
    </div>
  );
};

export default ClientLayout;
